const movimientos = state => state.movimientos;


export default {
  movimientos,
};